import BaseAPI from '../base/baseApi';
import httpClient from '@/apis/base/httpclient';
import FileAPI from './fileAPI';
import store from '@/stores/store';
import { ModuleExport } from '@/stores/moduleConst.js';
import { ExportStatus } from '@/commons/enumExport.js';
import { MSEnum } from '@/commons/enumeration';

class ExportDynamicAPI extends BaseAPI {
  constructor() {
    super();
  }

  apiName = 'Export';
  controllerName = 'dynamics';

  /**
   * xuất khẩu báo cáo
   * @param {*} param
   * @returns
   * created by lkphuc 01.03.2023
   * modified by lkphuc 09.03.2023 chạy luồng setInterval để kéo file về
   */
  async export(param) {
    let request = {
      url: `${this.getAPIUrl()}/parameter`,
      data: param,
      transformResponse: (res) => {
        return res;
      },
    };

    let fileNameClient = `misa-xuat-khau.xlsx`;
    if (param && param.ParamData && param.ParamData.FileName) {
      fileNameClient = param.ParamData.FileName;
    }

    var res = await httpClient.postAsync(request);
    if (res) {
      store.commit(`${ModuleExport}/addExportProcess`, {
        nameFileServer: res,
        nameFileClient: fileNameClient,
      });

      this.getTempFile(res, fileNameClient);
    }
  }

  /**
   * download file về client
   * 1. check exist temp file
   * 2. mở tab mới để down file
   * 3. cơ chế
   * @param {*} nameFileServer
   * @param {*} nameFileClient
   * created by lkphuc 02.03.2023
   * modified by lkphuc 09.03.2023 xử lý lưu trạng thái xuất khẩu
   */
  getTempFile(nameFileServer, nameFileClient) {
    var fn = async function (i) {
      if (i < window._appConfig.checkTempFileTimes) {
        let notExist = await FileAPI.checkExistTempFile(nameFileServer);
        let process =
          store.getters[`${ModuleExport}/exportProcess`](nameFileServer);
        if (
          !notExist &&
          process &&
          process.Status == ExportStatus.InProcessing
        ) {
          store.commit(
            `${ModuleExport}/updateSuccessStatusExportProcess`,
            process.NameFileServer
          );

          let src = FileAPI.getDownloadLink(
            0,
            nameFileServer,
            nameFileClient,
            'ETask'
          );
          window.open(src);
          return;
        } else {
          if (notExist) {
            if (i == window._appConfig.checkTempFileTimes - 1) {
              store.commit(
                `${ModuleExport}/removeExportProcess`,
                nameFileServer
              );
            }

            setTimeout(() => {
              fn(i);
            }, window._appConfig.checkTempFileSleep);
          }
        }
      }
      i++;
    };
    fn(0);
  }
}

export default new ExportDynamicAPI();
